var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.49 34.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.63,13.9l-6.19-10.73c-1.14-1.97-3.24-3.18-5.51-3.18h-12.38c-2.27,0-4.37,1.21-5.51,3.18L.85,13.9c-1.14,1.97-1.14,4.39,0,6.36l6.19,10.73c1.14,1.97,3.24,3.18,5.51,3.18h12.38c2.27,0,4.37-1.21,5.51-3.18l6.19-10.73c1.14-1.97,1.14-4.39,0-6.36ZM28.21,14.45c-1.93-.25-3.64-.93-5.1-2.36,0,.2,0,.31,0,.42,0,2.78.05,5.56-.02,8.34-.08,3.14-1.61,5.41-4.49,6.66-3.07,1.34-6.72.26-8.67-2.47-1.97-2.76-1.8-6.52.44-9.04,1.47-1.65,3.31-2.47,5.52-2.48.39,0,.78,0,1.17,0,.02,0,.04.01.09.02v3.79c-.43,0-.86,0-1.29,0-.68,0-1.32.17-1.89.55-1.4.92-1.96,2.66-1.35,4.18.63,1.56,2.23,2.43,3.91,2.11,1.58-.3,2.75-1.72,2.75-3.38,0-4.71,0-9.41,0-14.12v-.44c.14,0,.25-.02.36-.02,1.04,0,2.07,0,3.11,0,.26,0,.39.08.51.3.55,1.06,1.26,2,2.18,2.78.87.73,1.85,1.22,2.98,1.39.16.02.31.06.52.1-.24,1.23-.48,2.43-.72,3.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tik tok.6e698d425173bc1330ec2ceac425d303.svg";
export { ForwardRef as ReactComponent };